import { render, staticRenderFns } from "./miniProgramLinkList.vue?vue&type=template&id=855f5ae4&scoped=true"
import script from "./miniProgramLinkList.vue?vue&type=script&lang=js"
export * from "./miniProgramLinkList.vue?vue&type=script&lang=js"
import style0 from "./miniProgramLinkList.vue?vue&type=style&index=0&id=855f5ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855f5ae4",
  null
  
)

export default component.exports